let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("4rxdc")).then(() => parcelRequire('kHZ9E'));